import React, { createContext, useContext, useState, useEffect, ReactNode } from 'react';
import { User as FirebaseUser, onAuthStateChanged } from 'firebase/auth';
import { auth } from '../firebaseConfig';

interface UserContextValue {
  user:        FirebaseUser | null;
  loadingAuth: boolean;
}

const UserContext = createContext<UserContextValue>({ user: null, loadingAuth: true });

export const UserProvider = ({ children }: { children: ReactNode }) => {
  const [user, setUser]               = useState<FirebaseUser | null>(null);
  const [loadingAuth, setLoadingAuth] = useState(true);

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, (u) => {
      setUser(u);
      setLoadingAuth(false);
    });
    return unsub;
  }, []);

  return (
    <UserContext.Provider value={{ user, loadingAuth }}>
      {children}
    </UserContext.Provider>
  );
};

export const useUser = () => useContext(UserContext);
